import { getSalesAgentInfo, SalesAgentInfoProps } from 'merchant-api/spiceroad';
import { useApplication, useApplicationProps } from 'merchant-api/unified';
import { useEffect } from 'react';
import { CheckoutBlockingErrorContext } from 'merchant-api/types';
import { useAnalytics } from 'use-analytics';
import { DefaultErrorPage } from '@odmonorepo/core-components';
import OffersExpiredError from './OffersExpiredError';
import { AppError } from 'merchant-api';
import { errorWithLayout } from './ErrorPage';
import NewUser from './NewUser';
import ContactUs from './ContactUs';

interface SalesAlertErrorProps {
  error: AppError;
}

export const SalesAlertError = (props: SalesAlertErrorProps) => {
  const salesAgentInfoProps = getSalesAgentInfo();
  const useApplicationProps = useApplication();
  const analytics = useAnalytics();

  useEffect(() => {
    if (props.error.salesAgentAction == null) return;

    trackCheckoutBlockingError(analytics, props.error, salesAgentInfoProps, useApplicationProps);
  }, [salesAgentInfoProps.salesAgentInfo, useApplicationProps.opportunityId]);

  switch (props.error.name) {
    case 'OffersExpired':
      return errorWithLayout(<OffersExpiredError />);
    case 'MultiOwner':
      return errorWithLayout(<ContactUs />);
    case 'NewUser':
      return errorWithLayout(<NewUser />);
    default:
      return errorWithLayout(<DefaultErrorPage />);
  }
};

export const trackCheckoutBlockingError = (analytics: any, error: AppError, salesAgentInfoProps: SalesAgentInfoProps, useApplicationProps: useApplicationProps) => {
  if (analytics.plugins == null || analytics.plugins['datadog-rum'] == null) return;

  const { salesAgentInfo, isSalesAgentInfoLoading } = salesAgentInfoProps;
  const { opportunityId, isLoadingApplication } = useApplicationProps;
  if (isSalesAgentInfoLoading || isLoadingApplication || salesAgentInfo?.email == null) return;

  let errorContext: CheckoutBlockingErrorContext = buildCheckoutBlockingErrorContext(error, salesAgentInfo.email, opportunityId);

  analytics.plugins['datadog-rum'].trackError(error, errorContext);
};

const buildCheckoutBlockingErrorContext = (error: AppError, salesAgentEmail: string, opportunityId?: string): CheckoutBlockingErrorContext => {
  let errorContext: CheckoutBlockingErrorContext = {} as CheckoutBlockingErrorContext;
  errorContext.salesAgentEmail = salesAgentEmail;
  errorContext.salesAgentAction = error.salesAgentAction || 'Unknown action, please contact support.';
  errorContext.errorLevel = 'Checkout Blocking Error';
  if (opportunityId != null) {
    errorContext.opportunityId = opportunityId;
  }

  return errorContext;
};
